<script lang="ts" setup>
defineProps<{
  name: string
  label: string
  selected: boolean
}>()

const emit = defineEmits<{
  select: []
}>()
</script>

<template>
  <div class="decline-row">
    <label class="decline-select">
      <input class="radio" type="radio" :name="name" :checked="selected" @change="emit('select')" />
      <span class="decline-label text-small">{{ label }}</span>
    </label>
  </div>
</template>

<style lang="scss" scoped>
.decline-row {
  border-top: 1px solid var(--c-line-light);
  padding: 20px 0;
}

.decline-select {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;

  cursor: pointer;

  @include breakpoint(tl) {
    gap: 24px;
  }

  .radio {
    appearance: none;

    position: relative;

    width: 26px;
    height: 26px;
    min-width: 26px;

    margin: 0;

    border: 1px solid var(--form-input-border-color);
    border-radius: 50%;

    background: var(--c-white);

    cursor: pointer;

    @include transitions(border, background);

    &:checked {
      background: var(--c-blue-100);
      border-color: var(--c-blue-100);

      &:after {
        content: '';

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        width: 13px;
        height: 13px;

        border-radius: 50%;
        background: var(--c-white);
      }
    }
  }

  .decline-label {
    min-width: 0;
    overflow-wrap: anywhere;

    color: var(--c-gray-100);
  }
}
</style>
